<template>
  <div class="standard-sub-grid character-grid">
    <div class="level-title">
      Level
    </div>
    <div class="level-value">
      {{ charData.currentLevel }}
    </div>
    <div class="hit-points">
      <span class="text-green">HP:</span>
      <span>
        {{ charData.hitPoints }}
      </span>
    </div>
    <div class="xp-title">
      XP
    </div>
    <div class="xp-value">
      {{ charData.xp }}
    </div>
    <div class="character-image">
      <img
        :src="getAvatar()"
        alt=""
      >
    </div>
    <div class="next-level-title">
      Next Level
    </div>
    <div
      class="next-level-value"
      :title="`XP needed to level up: ${charData.step}`"
    >
      {{ charData.next }}
    </div>
    <div class="trait-1-title">
      Trait 1
    </div>
    <div class="trait-1-value">
      {{ charData.trait1 }}
    </div>
    <div class="trait-2-title">
      Trait 2
    </div>
    <div class="trait-2-value">
      {{ charData.trait2 }}
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex"
import { computed, defineComponent } from "vue"
export default defineComponent({
 name: "CharacterTable",
 components: {},
 setup() {
   const store = useStore();
   const charData = computed(() => {
     const xp = (store.state.build.info.currentLevel * ((store.state.build.info.currentLevel - 1) * 1000) / 2);
     const step = store.state.build.info.currentLevel * 1000 || 1000;
     return {
       currentLevel: store.state.build.info.currentLevel,
       hitPoints: Math.round(store.state.build.CharStats.HitPoints.value),
       xp: Math.abs(xp).toLocaleString(),
       step: step.toLocaleString(),
       next: (xp + step).toLocaleString(),
       trait1: store.state.build.info.Traits[0] || 'None',
       trait2: store.state.build.info.Traits[1] || 'None',
     }
   });
   
   const getAvatar = () => {
    return store.getters['getAvatar'].image;
   };
   
    return {
      state: store.state,
      charData,
      getAvatar,
   }
 },
})
</script>
<!-- REVISED -->
<style scoped>
.standard-sub-grid {
  display: grid;
  grid-template-rows: auto;
  font-size: 14px;
  gap: 2px;
  width: 95%;
  margin: auto;
  padding: 2px;
  border: var(--border-light);
  border-radius: 3px;
  background-color: var(--sub-panel-bg);
  box-sizing: border-box;
}
.standard-sub-grid:hover {
  border: 1px solid rgba(145, 255, 55, 0.728);
}
.character-grid {
  grid-template-columns: 72px 125px auto;
  grid-template-areas:
    "level-title level-value hit-points"
    "xp-title xp-value character-image"
    "next-level-title next-level-value character-image"
    "trait-1-title trait-1-value character-image"
    "trait-2-title trait-2-value character-image";
}
.level-title {
  grid-area: level-title;
}
.level-value {
  grid-area: level-value;
}
.xp-title {
  grid-area: xp-title;
}
.xp-value {
  grid-area: xp-value;
}
.hit-points {
  grid-area: hit-points;
}
.character-image {
  grid-area: character-image;
}
.next-level-title {
  grid-area: next-level-title;
}
.next-level-value {
  grid-area: next-level-value;
}
.trait-1-title {
  grid-area: trait-1-title;
}
.trait-1-value {
  grid-area: trait-1-value;
}
.trait-2-title {
  grid-area: trait-2-title;
}
.trait-2-value {
  grid-area: trait-2-value;
}
.level-title,
.level-value,
.xp-title,
.xp-value,
.hit-points,
.character-image,
.next-level-title,
.next-level-value,
.trait-1-title,
.trait-1-value,
.trait-2-title,
.trait-2-value {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 18px;
}
.xp-title,
.xp-value,
.character-image,
.trait-1-title,
.trait-1-value {
  background: var(--tr-bg-2);
  border: 1px solid var(--sub-panel-bg);
  border-radius: 3px;
}

.level-value,
.xp-value,
.character-image,
.next-level-value,
.hit-points,
.trait-1-value,
.trait-2-value {
  color: white;
  border: var(--td-border);
  border-radius: 3px;
}
.hit-points {
  display: flex;
  justify-content: space-evenly;
}

</style>